import Storage from '@/services/Storage'

export default {
  state: {
    items: Storage.getItem('wishlist-items') ? JSON.parse(Storage.getItem('wishlist-items')) : {},
    checkoutStatus: null,
    isFetching: null,
    isChecking: false,
    error: null,
    version: '1.0'
  },
  getters: {
    wishlistIsChecking: state => state.isChecking,
    wishlist: state => tourId => {
      return state.items[tourId] ? state.items[tourId] : []
    },
    wishlistIsFetching: state => state.isFetching,
    wishlistError: state => state.error,
    wishlistCheckoutStatus: state => state.checkoutStatus,
    wishlistItemsNumber: state => tourId => {
      let sum = 0
      if (state.items[tourId]) Object.values(state.items[tourId]).map(item => (sum += item.qty))
      return sum
    }
  },
  mutations: {
    WISHLIST_IS_CHECKING(state, value = true) {
      state.isChecking = value
    },
    WISHLIST_ERROR(state, error) {
      state.isFetching = false
      state.error = error
    },
    PUSH_NEW_ITEM_TO_WISHLIST(state, { product, tourId }) {
      let items = state.items[tourId]

      if (state.items[tourId]) {
        items.push(product)
      } else {
        items = [product]
      }
      state.items = { ...state.items, [tourId]: items }
      Storage.setItem('wishlist-items', JSON.stringify(state.items))
    },
    UPDATE_EXISTING_WISHLIST_ITEM(state, { product, tourId }) {
      let items = state.items[tourId]
      const itemId = product.contentId
      const indexOfItem = state.items[tourId].findIndex(({ contentId }) => contentId === itemId)
      const item = state.items[tourId].find(({ contentId }) => contentId === itemId)
      item.qty += product.qty
      items.splice(indexOfItem, 1, item)
      state.items = { ...state.items, [tourId]: items }
      Storage.setItem('wishlist-items', JSON.stringify(state.items))
    },
    INCREMENT_ITEM_QUANTITY(state, { itemId, tourId }) {
      let items = state.items[tourId]
      const indexOfItem = state.items[tourId].findIndex(({ contentId }) => contentId === itemId)
      const item = state.items[tourId].find(({ contentId }) => contentId === itemId)
      item.qty++
      items.splice(indexOfItem, 1, item)
      state.items = { ...state.items, [tourId]: items }
      Storage.setItem('wishlist-items', JSON.stringify(state.items))
    },
    DECREMENT_ITEM_QUANTITY(state, { itemId, tourId }) {
      let items = state.items[tourId]
      const indexOfItem = state.items[tourId].findIndex(({ contentId }) => contentId === itemId)
      const item = state.items[tourId].find(({ contentId }) => contentId === itemId)
      item.qty--
      if (item.qty <= 0) {
        items.splice(indexOfItem, 1)
      } else {
        items.splice(indexOfItem, 1, item)
      }
      state.items = { ...state.items, [tourId]: items }
      Storage.setItem('wishlist-items', JSON.stringify(state.items))
    },
    SET_ITEMS(state, items) {
      state.items = items
      Storage.setItem('wishlist-items', JSON.stringify(state.items))
    },
    SET_WISHLIST_ITEMS(state, { savedWishlistItems, tourId }) {
      let items = state.items[tourId]
      items = savedWishlistItems
      state.items = { ...state.items, [tourId]: items }
      Storage.setItem('wishlist-items', JSON.stringify(state.items))
    },
    SET_CHECKOUT_STATUS(state, status) {
      state.checkoutStatus = status
    },
    WISHLIST_CLEAR(state, tourId) {
      let items = state.items[tourId]
      items = []
      state.items = { ...state.items, [tourId]: items }
      Storage.setItem('wishlist-items', JSON.stringify(state.items))
    },
    DELETE_ITEM(state, { itemId, tourId }) {
      let items = state.items[tourId]
      const indexOfItem = state.items[tourId].findIndex(({ contentId }) => contentId === itemId)

      items.splice(indexOfItem, 1)
      state.items = { ...state.items, [tourId]: items }
      Storage.setItem('wishlist-items', JSON.stringify(state.items))
    }
  },
  actions: {
    WISHLIST_CHECK_LOCAL_STORAGE_VERSION({ commit, state }) {
      return new Promise(resolve => {
        commit('WISHLIST_IS_CHECKING')
        if (state.items['__VERSION__'] === state.version) {
          commit('WISHLIST_IS_CHECKING', false)
          resolve(true)
        } else {
          commit('SET_ITEMS', { __VERSION__: state.version })
          commit('WISHLIST_IS_CHECKING', false)
          resolve(false)
        }
      })
    },
    WISHLIST_CHECKOUT({ state, commit }, tourId) {
      const savedWishlistItems = [...state.items[tourId]]
      commit('SET_WISHLIST_ITEMS', { savedWishlistItems, tourId })
      commit('SET_CHECKOUT_STATUS', true)
    },
    WISHLIST_ADD_ITEM({ state, commit }, { product, tourId }) {
      commit('SET_CHECKOUT_STATUS', null)
      const itemId = product.contentId
      if (state.items[tourId] === undefined || !state.items[tourId].find(item => item.contentId === itemId)) {
        commit('PUSH_NEW_ITEM_TO_WISHLIST', { product, tourId })
      } else {
        commit('UPDATE_EXISTING_WISHLIST_ITEM', { product, tourId })
      }
    },
    WISHLIST_GET_ITEMS({ commit }) {
      commit('SET_CHECKOUT_STATUS', null)
    },
    WISHLIST_CLEAR({ commit }, tourId) {
      commit('WISHLIST_CLEAR', tourId)
    },
    WISHLIST_DELETE_ITEM({ commit }, { itemId, tourId }) {
      commit('DELETE_ITEM', { itemId, tourId })
    },
    WISHLIST_INCREMENT_ITEM_QUANTITY({ commit }, { itemId, tourId }) {
      commit('INCREMENT_ITEM_QUANTITY', { itemId, tourId })
    },
    WISHLIST_DECREMENT_ITEM_QUANTITY({ commit }, { itemId, tourId }) {
      commit('DECREMENT_ITEM_QUANTITY', { itemId, tourId })
    }
  }
}
